module.exports = __webpack_public_path__ + "img/earth4.bcbaccd8.jpg";